import _ from "lodash";
import { useState } from "react";
import { Chip, Menu, MenuItem, Tooltip } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { IconPennant2 } from "@tabler/icons-react";
import { blue } from "@mui/material/colors";
import AnalyticsService from "data/firestore/analytics";
import useCustomSnackbar from "hooks/customSnackbar";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      fontSize: 14,
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function AlbumSelect({
  albums,
  album,
  allowChanges,
  numberOfImages,
  onChange,
}) {
  const { enqueueSnackbar } = useCustomSnackbar();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  function attemptChange(selectedAlbum = "") {
    if (allowChanges) {
      onChange(selectedAlbum);
    } else {
      enqueueSnackbar("This feature is only available to members", {
        variant: "warning",
      });
    }
    AnalyticsService.event("set_timeline_album", {
      specificAlbum: selectedAlbum !== "",
      failed: !allowChanges,
    });
    handleClose(); // Close menu after selection
  }

  return (
    <>
      <Tooltip title="Starred Images" arrow>
        <Chip
          variant="outlined"
          icon={<IconPennant2 style={{ color: blue[500] }} />}
          label={album || (numberOfImages ? "All Photos" : "No Photos")}
          disabled={numberOfImages === 0}
          onClick={handleClick}
          onDelete={handleClick} // Clicking the dropdown icon also opens menu
          deleteIcon={<KeyboardArrowDownIcon />}
          sx={{
            borderRadius: 20,
            fontSize: 14,
            padding: "4px 8px",
            color: blue[500],
            borderColor: blue[500],
            "&:hover": { backgroundColor: alpha(blue[500], 0.1) },
          }}
        />
      </Tooltip>
      <StyledMenu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => attemptChange("")}
          style={{ color: album === "" ? blue[500] : "inherit" }}
        >
          All Photos
        </MenuItem>
        {_.map(albums, (a) => (
          <MenuItem
            key={a}
            onClick={() => attemptChange(a)}
            style={{ color: album === a ? blue[500] : "inherit" }}
          >
            {a}
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  );
}
